const subscriptionInputs = document.querySelectorAll('[name="product-type"]');
const subscriptionCards = document.querySelectorAll('.subscription-card')


/* this is just to change colours */
subscriptionInputs.forEach( subscriptionInput => {
  const subscriptionCard = subscriptionInput.parentElement

  subscriptionInput.addEventListener('change', function() {
    subscriptionCards.forEach( subscriptionCard => { subscriptionCard.classList.remove('selected') })
    if (this.checked) {
      subscriptionCard.classList.add('selected');
    }
  });
})

subscriptionCards.forEach( subscriptionCard => {
  const sizes = subscriptionCard.querySelector('[name="Size"]')
  const packs = subscriptionCard.querySelectorAll('[name="Packs"]')
  const quantity = subscriptionCard.querySelector('[name="quantity"]')
  const variants = subscriptionCard.querySelector('[name="id"]')
  const frequencies = subscriptionCard.querySelectorAll('[name="selling_plan"]')
  const addToCartButton = subscriptionCard.querySelector('.subscription-add-to-cart')
  if(sizes) var selectedSize = sizes.value
  if(packs) var selectedPack = subscriptionCard.querySelector('[name="Packs"]:checked')?.value
  const totalPrice = subscriptionCard.querySelector('.subscription-total-price')
  const minusBtn = quantity.previousElementSibling
  const plusBtn = quantity.nextElementSibling

  //TODO
  variants.addEventListener('change', () => {
    updatePrice()
  })  

  //size dropdown
  if(sizes){
    sizes.addEventListener('change', () => {
      if(packs) var selectedPack = packs.value
      selectedSize = sizes.value
      if(packs) selectedPack = subscriptionCard.querySelector('[name="Packs"]:checked')?.value
      
      //selected corresponding variant
      //console.log(selectedSize, selectedPack, sizes, packs)
      if(sizes && packs) variants.value = Array.from(variants).find( variant => {return variant.dataset.size === selectedSize && variant.dataset.packs === selectedPack} )?.value
      if(!sizes) variants.value = Array.from(variants).find( variant => { return variant.dataset.packs === selectedPack } )?.value
      if(!packs) variants.value = Array.from(variants).find( variant => { return variant.dataset.size === selectedSize } )?.value
      let changeEvent = new Event('change')
      variants.dispatchEvent(changeEvent)

      subscriptionCards.forEach( subsCard => {
        if(subsCard != subscriptionCard){
          let subsCardSize = subsCard.querySelector('[name="Size"]')
          if(subsCardSize.value != selectedSize){
            subsCardSize.value = selectedSize
            let changeEvent2 = new Event('change')
            subsCardSize.dispatchEvent(changeEvent2)
          }          
        }
      })
    })
  }

  if(packs){
    var selectedPack = packs.value
    //change selected variant
    packs.forEach( pack => {
      pack.addEventListener('change', () => {
        if(sizes) selectedSize = sizes.value
        selectedPack = subscriptionCard.querySelector('[name="Packs"]:checked')?.value
        
        console.log(selectedPack, sizes, packs)
        if(sizes && packs) variants.value = Array.from(variants).find( variant => {return variant.dataset.size === selectedSize && variant.dataset.packs === selectedPack} )?.value
        if(!sizes) variants.value = Array.from(variants).find( variant => { return variant.dataset.packs === selectedPack } )?.value
        if(!packs) variants.value = Array.from(variants).find( variant => { return variant.dataset.size === selectedSize } )?.value
        let changeEvent = new Event('change')
        variants.dispatchEvent(changeEvent)
      })
    })
    
  }

  if(frequencies){
    frequencies.forEach(frequency => {
      frequency.addEventListener('click', () => {
        updatePrice()
      })
    })
  }  

  function updatePrice(){
    if(sizes) selectedSize = sizes.value
    if(packs)  selectedPack = subscriptionCard.querySelector('[name="Packs"]:checked')?.value
    if(frequencies) selectedFrequency = subscriptionCard.querySelector('[name="selling_plan"]:checked')

    const selectedVariant = subscriptionCard.querySelector('[name="id"] option:checked')
    const variantPrice = selectedVariant.dataset.price
    const variantCompareAtPrice = selectedVariant.dataset.compareat
    let finalVariantPrice = variantPrice
    if(selectedFrequency && selectedFrequency.dataset.adjustment) finalVariantPrice = "£" + (parseFloat(variantPrice.replace("£","")) * (1 - parseFloat(selectedFrequency.dataset.adjustment))).toFixed(2);

    //console.log(selectedVariant, variantPrice, variantCompareAtPrice, finalVariantPrice, "xxx", selectedFrequency.dataset.adjustment)
    
    //change price
    totalPrice.innerHTML = `Total ${finalVariantPrice}`;
    if(variantCompareAtPrice) totalPrice.innerHTML += `<span class="subscription-total-discount">${variantCompareAtPrice}</span>`
  }

  minusBtn.addEventListener('click', () => {
    if(quantity.value > 0) quantity.value = parseInt(quantity.value) - 1;
  })
  
  plusBtn.addEventListener('click', () => {
    quantity.value = parseInt(quantity.value) + 1;
  })

  let changeEvent = new Event('change')
  variants.dispatchEvent(changeEvent)

  addToCartButton.addEventListener('click', (e) => {
    if(sizes.length > 0 ){ 
      const selectedSize = subscriptionCard.querySelector('[name="Size"] option:checked')
      if(!selectedSize|| !selectedSize.value){
        e.preventDefault()
        showModalMessage("Please select a size")
        return false;
      }
    }
    
    if(frequencies.length > 0 ){    
      const selectedFrequency = subscriptionCard.querySelector('[name="selling_plan"]:checked')
      if(!selectedFrequency || !selectedFrequency.value){
        e.preventDefault()  
        showModalMessage("Please select a frequency.")
        return false;
      }
    }

    
    return true;
  })
})

Array.from(subscriptionInputs)[0]?.click()